/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_action__sign_up = /** @type {(inputs: {}) => string} */ () => {
	return `Registrierung`
};

const en_action__sign_up = /** @type {(inputs: {}) => string} */ () => {
	return `Sign up`
};

const es_action__sign_up = /** @type {(inputs: {}) => string} */ () => {
	return `Inscripción`
};

const fr_action__sign_up = /** @type {(inputs: {}) => string} */ () => {
	return `Inscription`
};

const it_action__sign_up = /** @type {(inputs: {}) => string} */ () => {
	return `Iscrizione`
};

const nl_action__sign_up = /** @type {(inputs: {}) => string} */ () => {
	return `Inschrijving`
};

const pt_action__sign_up = /** @type {(inputs: {}) => string} */ () => {
	return `Registo`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const action__sign_up = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.action__sign_up(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("action__sign_up", locale)
	if (locale === "de") return de_action__sign_up(inputs)
	if (locale === "en") return en_action__sign_up(inputs)
	if (locale === "es") return es_action__sign_up(inputs)
	if (locale === "fr") return fr_action__sign_up(inputs)
	if (locale === "it") return it_action__sign_up(inputs)
	if (locale === "nl") return nl_action__sign_up(inputs)
	return pt_action__sign_up(inputs)
};